export class Memento {
    props: { [group: string]: string };
    colors: { [color: string]: string };
    assetPack: string;

    constructor() {
        this.props = {};
        this.colors = {};
        this.assetPack = "";
    }

    toHash() {
        let propParts = [];
        let colorParts = [];
        for (const propName in this.props) {
            propParts.push(propName + "=" + this.props[propName]);
        }
        for (const colorName in this.colors) {
            colorParts.push(colorName + "=" + this.colors[colorName].replace("#", "0x"));
        }
        return this.assetPack + ":" + propParts.join(";") + ":" + colorParts.join(";");
    }

    static fromHash(hash: string) {
        let memento = new Memento();

        if (hash.startsWith("#"))
            hash = hash.substring(1);

        let split1 = hash.split(":");

        memento.assetPack = split1[0];

        if (split1.length < 2) return memento;

        for (const pair of split1[1].split(";")) {
            if (pair === "") continue;

            const split2 = pair.split("=");
            memento.props[split2[0]] = split2[1];
        }

        if (split1.length < 3) return memento;

        for (const pair of split1[2].split(";")) {
            if (pair == "") continue;

            const split2 = pair.split("=");
            memento.colors[split2[0]] = split2[1].replace("0x", "#");
        }

        return memento;
    }
}

